module.exports = __webpack_public_path__ + "img/smart_product0.032bbc29.png";